import { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

import { consentsSections, routePaths, strCode } from "../../../consts";
import { t } from "../../../services";

import { ConsentsTable } from "../../../containers";
import { FlexContainers, PageSelector, Paragraph2, WrapperContainer } from "../../../components";
import { dispatch } from "../../../state/store";
import { setSelectedConsent } from "../../../state/ducks";

const consentsPages = [
  { id: consentsSections.CONSENTS, title: strCode.CONSENTS_NAV_BTN },
  { id: consentsSections.DRAFTS, title: strCode.DRAFTS }
];

const Consents = ({
  consentsData = [],
  draftConsentsData = [],
  onDuplicateConsent = () => {},
  onDeleteDraft = () => {},
  onCreateConsent = () => {}
}) => {
  const [activePage, setActivePage] = useState(consentsSections.CONSENTS);

  const error = useSelector((store) => store.consents?.errors?.consents);

  const { appName } = useParams();

  const history = useHistory();

  const showConsentElements = (row) => {
    if (row?.id !== undefined) {
      dispatch(setSelectedConsent(null));
      history.push(
        `${routePaths.APPS}/${appName}${routePaths.CONSENTS_CONSENT_ELEMENTS}/${row.id}`
      );
    }
  };

  return (
    <>
      <PageSelector pages={consentsPages} activePage={activePage} setActivePage={setActivePage} />

      {error && (
        <WrapperContainer
          Container={FlexContainers.FlexColumnCenter}
          width={"100%"}
          mt={200}
          textAlign={"center"}>
          <Paragraph2>{t(strCode.CONSENTS_FETCH_ERROR)}</Paragraph2>
        </WrapperContainer>
      )}

      {!error && activePage === consentsSections.CONSENTS && (
        <ConsentsTable
          consentsData={consentsData}
          showConsentElements={showConsentElements}
          callbackFn={onDuplicateConsent}
          onCreateConsent={onCreateConsent}
          tooltipLabel={t(strCode.VIEW_DETAILS)}
        />
      )}

      {!error && activePage === consentsSections.DRAFTS && (
        <ConsentsTable
          consentsData={draftConsentsData}
          showConsentElements={showConsentElements}
          callbackFn={onDeleteDraft}
          onCreateConsent={onCreateConsent}
          tooltipLabel={t(strCode.VIEW_DETAILS)}
          isDraft
        />
      )}
    </>
  );
};

Consents.propTypes = {
  consentsData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      version: PropTypes.number.isRequired,
      market: PropTypes.string.isRequired,
      appType: PropTypes.string.isRequired,
      activatedAtTs: PropTypes.number.isRequired,
      deactivatedAtTs: PropTypes.number,
      status: PropTypes.string.isRequired,
      modifiedBy: PropTypes.string.isRequired
    })
  ),
  draftConsentsData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      version: PropTypes.number,
      market: PropTypes.string.isRequired,
      appType: PropTypes.string.isRequired,
      activatedAtTs: PropTypes.number,
      deactivatedAtTs: PropTypes.number,
      status: PropTypes.string.isRequired,
      modifiedBy: PropTypes.string.isRequired
    })
  ),
  getConsentElements: PropTypes.func,
  onDuplicateConsent: PropTypes.func.isRequired,
  onDeleteDraft: PropTypes.func.isRequired,
  onCreateConsent: PropTypes.func.isRequired
};

export default Consents;
